import styled from 'styled-components'

import Button from '~/components/button'
import CheckboxInput from '~/components/checkbox-input'
import ContentBlock from '~/components/content-block'
import ProfilePicture from '~/components/profile-picture'
import { color, device, font } from '~/styles/utils'

export const Heading = styled.div`
  padding: 5px 25px;
  background-color: ${({ theme }) => theme.color.background.accent};
  border: solid;
  text-align: center;
`

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 900;
  line-height: 1.3rem;
  margin: 0 0 15px 0;
  padding: 0;

  @media ${device('notMobile')} {
    margin: 0 0 25px 0;
  }
`

export const Label = styled.h2`
  font-size: 28px;
  margin: 16px 0;
  line-height: 1;
`

export const ScrollWrapper = styled.div`
  position: relative;
  border: 1px solid ${color('coolGrey')};
  box-sizing: border-box;
  padding: 0 18px;

  @media ${device('notMobile')} {
    height: calc(100vh - 540px);
    min-height: 330px;
    overflow-y: scroll;
  }
`

export const TermsContentBlock = styled(ContentBlock)`
  h4 {
    text-align: center;
    ${font('bold')};
  }
`

export const ContentWrapper = styled.div`
  padding: 15px;
  flex: 1 1 auto;
  overflow-y: auto;

  @media ${device('notMobile')} {
    padding: 40px 40px 20px;
  }
`

export const FooterWrapper = styled.form`
  flex-shrink: 0;
`

export const AgreeContentBlock = styled(ContentBlock)`
  padding: 4px 15px 16px 15px;
  background-color: ${({ theme }) => theme.color.background.dark};
  color: ${({ theme }) => theme.color.text.onDark};

  @media ${device('notMobile')} {
    padding: 7px 40px;
  }
`

export const Actions = styled.div`
  border-top: 1px solid ${color('coolGrey')};
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-items: center;

  @media ${device('notMobile')} {
    padding: 15px 40px;
  }
`

export const NextButton = styled(Button)`
  &&& {
    margin-top: 0;
    min-width: 150px;
  }

  border: 1px solid ${({ theme }) => theme.color.border.dark};
`

export const StyledCheckboxInput = styled(CheckboxInput)`
  input {
    background-color: white;
  }
`

export const StyledProfilePicture = styled(ProfilePicture)`
  width: 37px;
  height: 37px;
`

export const Releasors = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-bottom: 10px;

  @media ${device('notMobile')} {
    display: inline-flex;
    flex-direction: row;
    column-gap: 25px;
    padding-bottom: 22px;
  }
`

export const ReleasorsHeading = styled.p`
  margin: 22px 0 0;
  ${font('demi')};
  text-transform: uppercase;
`

export const Releasor = styled.div`
  display: inline-flex;
  column-gap: 8px;
  align-items: center;
  padding: 10px 0;
`

export const ReleasorName = styled.span`
  font-size: 14px;
  text-transform: uppercase;
`
